import { Injectable } from '@angular/core';
import * as Prismic from 'prismic-javascript';
import * as _ from 'lodash';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/publish';
import 'rxjs/add/operator/publishReplay';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'



const apiEndpoint = "https://thinslabz1.cdn.prismic.io/api/v2";

@Injectable()
export class CmsService {
  public ref;
  public home;
  public productsMain;
  public portfolio;
  public about;

  public refWrap(func) {
    if (!this.ref) {
      return this._http.get('https://thinslabz1.cdn.prismic.io/api/v2')
        .mergeMap((res: Response) => {
          let body = res.json();
          if (!(_.has(body, 'refs') && body.refs.length > 0)) {
            throw new Error('CmsService.getHome: No ref!');
          }
          this.ref = _.find(body.refs, (r) => r.id === 'master').ref;
          // console.log(res.json());
          // console.log(this.ref);
          return func();
        });

    }
    return func();
  }

  public _getHome() {
    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.getSingle('home', {});
    });
  }

  public _getCategory(slug: string) {
    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.getByUID('category', slug);
    });
  }

  public getCategory1(slug:string) {

    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.getByUID('category', slug, {'fetchLinks': ['product.name', 'product.featured_image', 'product.description']});
    });

  }

  public getCategoryProducts(cat:string, page?:number) {

    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.query([
        Prismic.Predicates.at('document.type', 'product'),
        Prismic.Predicates.at('my.product.category', cat)
      ], { pageSize : 8, page: page || 1 }
      )
    });
    //          Prismic.Predicates.at('my.product.category', cat),


  }

  // https://thinslabz1.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&lang=*&ref=WuoXcysAACsAFzMp&q=%5B%5Bat(my.product.uid%2C%20%22antique-wood%22)%5D%5D
  public _getProduct(id: string) {
    return Observable.create((observer) => {
      Prismic.getApi(apiEndpoint, {}).then(function (api) {
        return api.getByUID('product', id);
      }).then((doc) => {
        observer.next(doc);
        observer.complete();
      }).catch((err) => {
        console.error("getProduct: ", err);
      });


    });

  }

  public _getProductsMain() {
    return Prismic.getApi(apiEndpoint, {}).then(function (api) {
      return api.getSingle('products_main',
        { 'fetchLinks': ['product.name', 'product.featured_image'] }
      );
    });
  }

  public __getCategory(slug: string) {


    // const options = { params: new HttpParams().set('name', term) };
    return this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&lang=*&ref=master&q=%5B%5Bat(my.category.uid%2C%20%22${slug}%22)%5D%5D`)
      .map((res: Response) => res.json().results[0]);

  }


  public __getProduct(id: string) {


    // const options = { params: new HttpParams().set('name', term) };
    return this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&lang=*&ref=master&q=%5B%5Bat(my.product.uid%2C%20%22${id}%22)%5D%5D`)
      .map((res: Response) => res.json().results[0]);

  }

  public getCategory(slug:string):Observable<any> {
    return this.refWrap(()=> this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&fetchLinks=product.name%2Cproduct.featured_image%2Cproduct.description&lang=*&ref=${ this.ref }&q=%5B%5Bat(my.category.uid%2C%20%22${ slug }%22)%5D%5D`)
      .map((res: Response) => res.json().results[0])
    )
  }


  public getProduct(id:string):Observable<any> {
    return this.refWrap(()=>{
      return this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&lang=*&ref=${ this.ref }&q=%5B%5Bat(my.product.uid%2C%20%22${ id }%22)%5D%5D`)
      .map((res: Response) => res.json().results[0]);
    });
  }


  public __getProductsMain() {
    if (!this.productsMain) {

      // const options = { params: new HttpParams().set('name', term) };
      this.productsMain = this._http.get('https://thinslabz1.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&fetchLinks=product.name%2Cproduct.featured_image&ref=master&q=%5B%5Bat(document.type%2C%20%22products_main%22)%5D%5D')
        .map((res: Response) => res.json().results[0])
        //  .do(console.log)
        .publishReplay(1)
        .refCount();
    }
    return this.productsMain;
  }

  public getProductsMain() {
    if (!this.productsMain) {
      return this.refWrap(()=> {
        this.productsMain = this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?page=1&pageSize=1&fetchLinks=product.name%2Cproduct.featured_image&ref=${this.ref}&q=%5B%5Bat(document.type%2C%20%22products_main%22)%5D%5D`)
        .map((res: Response) => res.json().results[0])
        //  .do(console.log)
        .publishReplay(1)
        .refCount();
        return this.productsMain;
      });
    } else return this.productsMain; 


  }

  public getHome() {
    if (!this.home) {
      return this.refWrap(()=> {
        this.home = this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?q=[[at(document.id,"WuJkfSsAACoA9a_9")]]&ref=${this.ref}`)
          .map((res: Response) => res.json().results[0])
          //  .do(console.log)
          .publishReplay(1)
          .refCount();
        return this.home;
      });
    } else return this.home;


  }

  public getPortfolio() {
    if (!this.portfolio) {
      return this.refWrap(()=> {
        this.portfolio = this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?q=[[at(my.portfolio.uid,"portfolio")]]&ref=${this.ref}`)
          .map((res: Response) => res.json().results[0])
          //  .do(console.log)
          .publishReplay(1)
          .refCount();
        return this.portfolio;
      });
    } else return this.portfolio;


  }

  public getAbout() {
    if (!this.about) {
      return this.refWrap(()=> {
        this.about = this._http.get(`https://thinslabz1.cdn.prismic.io/api/v2/documents/search?q=[[at(my.content_page.uid,"about")]]&ref=${this.ref}`)
          .map((res: Response) => res.json().results[0])
          //  .do(console.log)
          .publishReplay(1)
          .refCount();
        return this.about;
      });
    } else return this.about;


  }

  constructor(private _http: Http) { }

}



// WEBPACK FOOTER //
// /tmp/build_0264da94/src/app/cms.service.ts